<template>
    <!-- Table Header - Only visible on md screens and up -->
    <div
        class="bg-muted/50 text-muted-foreground hidden rounded px-4 py-2 text-sm font-medium md:grid md:grid-cols-12 md:gap-4">
        <div class="col-span-4">Short Link</div>
        <div class="col-span-4">Original Link</div>
        <div class="col-span-2">QR Code</div>
        <div class="col-span-2">First Seen On</div>
    </div>

    <!-- Loading state -->
    <template v-if="isBusy">
        <PublicUrlShortenerLinksListItem v-for="i in 10" :key="i" is-busy />
    </template>

    <!-- Loaded items -->
    <PublicUrlShortenerLinksListItem
        v-else
        v-for="item in urlsAsync"
        :key="item.publicShortUrl.shortPath"
        :item />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { usePublicShortUrlsAsync } from '@/website/datasources'
import PublicUrlShortenerLinksListItem from './PublicUrlShortenerLinksListItem.vue'

const isBusy = ref(false)

const urlsAsync = usePublicShortUrlsAsync(undefined, isBusy)
</script>

<style scoped></style>
